// extracted by mini-css-extract-plugin
export default {"footer":"MainFooter_footer__xt-wZ"};